import script from "./ProcessStory.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessStory.vue?vue&type=script&setup=true&lang=js"

import "./ProcessStory.vue?vue&type=style&index=0&id=ae01ce44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae01ce44"]])

export default __exports__